import { render, staticRenderFns } from "./RepresentativeSales.vue?vue&type=template&id=7aaa50ec&"
import script from "./RepresentativeSales.vue?vue&type=script&lang=js&"
export * from "./RepresentativeSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports